module.exports = __webpack_public_path__ + "static/img/exploit1.c49b74c9.png";